"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_privacy__or__confidential(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "da71dbf4-7eb3-403e-a5ac-ac9c12405064",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1{stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:8px;}")), /*#__PURE__*/React.createElement("title", null, "privacy-confidential"), /*#__PURE__*/React.createElement("g", {
    id: "e4664ed1-24c6-43b5-8d82-29b7f9df3b7c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96,20,36,33.41v77.32c0,6.88,4.88,14.31,10.8,22.1,5.25,6.89,12.68,13.94,22.08,21C80.62,162.53,90.19,169,96,172c5.82-3,15.38-9.47,27.12-18.21,9.41-7,16.83-14.07,22.07-21C151.11,125,156,117.61,156,110.73V33.41Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.47,85a17.88,17.88,0,1,0-18.94,0l-8.41,40.21A6.36,6.36,0,0,0,84,132a7.15,7.15,0,0,0,.8,0h22.35a6.39,6.39,0,0,0,6.71-6,5.77,5.77,0,0,0,0-.72l-4.35-18.36Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 192,
    height: 192
  })));
}

var _default = ic_privacy__or__confidential;
exports.default = _default;